import React from "react";
import { array } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { CaseLedgerRetentionFields, CaseLedgerType_displayString, isRetentionType } from "../../../../../domain/codecs/CaseLedger";
import { TCaseLedgerEntryForm } from "../../../../../domain/codecs/form/CaseLedgerEntryForm";
import { penceToCopyText } from "../../../../../shared/src/util";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { CRMCodecEditForm } from "../../CRMCodecEditForm/CRMCodecEditForm";
import { CRMParagraph } from "../../Simple/CRMParagraph/CRMParagraph";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";

type TCaseRetentionsSectionProps = {
    entries: Array<TCaseLedgerEntryForm>;
    onChange: (entry: TCaseLedgerEntryForm) => void;
};

export const getRetentionEntries = (entries: Array<TCaseLedgerEntryForm>): Array<TCaseLedgerEntryForm> =>
    pipe(
        entries,
        array.filter((entry) => isRetentionType(entry.edited.type)),
    );

export const CRMCaseRetentionRows = (props: React.PropsWithChildren<TCaseRetentionsSectionProps>): JSX.Element =>
    <SpacingColumn spacing={CRMSpacing.LARGE}>
        {getRetentionEntries(props.entries).map((entry) =>
            <SpacingColumn key={entry.edited.id} spacing={CRMSpacing.MEDIUM}>
                <SpacingRow spacing={CRMSpacing.MEDIUM} childSize="1fr auto">
                    <CRMParagraph>
                        <WeightSemiBold>
                            {CaseLedgerType_displayString(entry.edited.type)}
                        </WeightSemiBold>
                    </CRMParagraph>
                    <CRMParagraph>
                        <WeightSemiBold>
                            {penceToCopyText(entry.original.vat_excluded_amount_gbp_pence + entry.original.vat_amount_gbp_pence)}
                        </WeightSemiBold>
                    </CRMParagraph>
                </SpacingRow>

                <CRMCodecEditForm
                    codec={CaseLedgerRetentionFields}
                    model={entry.edited}
                    validationErrors={entry.validationErrors}
                    columns={1}
                    onChange={(edited) => props.onChange({
                        ...entry,
                        edited: { ...entry.edited, ...edited },
                    })}
                />
            </SpacingColumn>
        )}
    </SpacingColumn>
;
